import FieldUser from "../../../../fields3/generic/user/user"
import FieldConfig from "../../../proto/field-config"
import Project from "../../../../model2/project/project"
import {ProjectAccess} from "../../../../gd/const/project"

export default class FieldProjectOwner extends FieldUser {

    constructor(config:FieldConfig) {
        super(config)

        this.icon      = 'i5-user'
        this.typeLabel = "Project Owner";

        this.components = _.assign({}, this.components, {
            PopoverMenuMore : null,
        })
    }

    canEdit(model: Project): boolean {
        return model.acl.canChangeProjectOwner
    }

    access(model:any) {
        const access = gd.ac.check.project.fullAccess(model.id) ? 'write' : 'read'
        return access;
    }

    // we know projectId so need specific users only here
    getOptionsForEdit(model:any) {
        const projectId = _.get(model, 'id', null)

        if (projectId) {
            const projectUsers = gd.session.projectUsers.filterByProject(projectId, ProjectAccess.LIMITED)
            return projectUsers.map((projectUser:any)=>{
                return {
                    value: projectUser.user.id,
                    label: projectUser.user.name
                }
            })
        }

        return this.getOptions()
    }
}
